import { render, staticRenderFns } from "./QuestionSet.vue?vue&type=template&id=50469afa&scoped=true"
import script from "./QuestionSet.vue?vue&type=script&lang=js"
export * from "./QuestionSet.vue?vue&type=script&lang=js"
import style0 from "./QuestionSet.vue?vue&type=style&index=0&id=50469afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50469afa",
  null
  
)

export default component.exports